import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DefaultLayout from '../../layout/DefaultLayout';
import Loading from '../../components/Loading';
import Alert from '../../components/Alert';
import notificationService from '../../services/notificationService';

const STORAGE_KEY = 'notificationResponse';

const NotificacionDetalle: React.FC = () => {
  const navigate = useNavigate();
  const [notification, setNotification] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const markNotificationAsVerified = async (idNotificacion: number | string) => {
    try {
      if (!notificationService.updateNotificationsStatus) return;
      const res: any = await notificationService.updateNotificationsStatus(String(idNotificacion));
      if (res?.success) {
        console.debug('Notificación marcada como verificada', idNotificacion);
      } else {
        console.warn('Error marcando notificación como verificada', res?.errors);
      }
    } catch (ex) {
      console.error('Error al marcar notificación como verificada', ex);
    }
  };

  useEffect(() => {
    const fetchNotification = async () => {
      setLoading(true);
      setError(null);

      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) {
          setError('No se encontró la información de la notificación.');
          setLoading(false);
          return;
        }

        const parsed = JSON.parse(raw);
        setNotification(parsed);

        // remove stored item
        try { localStorage.removeItem(STORAGE_KEY); } catch {}

        if (parsed?.idnotificacion) {
          await markNotificationAsVerified(parsed.idnotificacion);
        }
      } catch (ex: any) {
        console.error('Error leyendo notificación', ex);
        setError('Hubo un error al cargar los detalles de la notificación.');
      } finally {
        setLoading(false);
      }
    };

    fetchNotification();
  }, []);

  if (loading) {
    return (
      <DefaultLayout>
        <div className="p-6">
          <Loading statusText="Cargando..." />
        </div>
      </DefaultLayout>
    );
  }

  if (error) {
    return (
      <DefaultLayout>
        <div className="p-6">
          <Alert type="failure" message={error} />
        </div>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout>
      <div className="p-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-2xl font-semibold mb-4">{notification?.title ?? 'Detalle de notificación'}</h1>

          {notification ? (
            <div className="bg-white dark:bg-boxdark p-4 rounded shadow-sm">
              <div className="mb-4">
                <div className="text-sm text-gray-500">Fecha</div>
                <div className="text-sm font-semibold">
                  {notification.date ? new Date(notification.date).toLocaleDateString('es-ES') : 'Fecha no disponible'}
                </div>
              </div>

              <div className="mb-4">
                <div className="text-sm text-gray-500 mb-2">Mensaje</div>
                <div
                  className="prose max-w-none text-sm"
                  // NOTE: message is rendered as HTML to preserve links. Ensure content is trusted/sanitized on the server.
                  dangerouslySetInnerHTML={{ __html: notification.message ?? '' }}
                />
              </div>
            </div>
          ) : (
            <div className="bg-white dark:bg-boxdark p-4 rounded text-center text-gray-600">No hay información disponible.</div>
          )}

          <div className="mt-6 flex justify-center">
            <button
              onClick={() => navigate(-1)}
              className="px-4 py-2 rounded bg-primario-celeste-800 text-white hover:bg-primario-azul-900"
            >
              Volver
            </button>
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default NotificacionDetalle;